import differenceInDays from "date-fns/differenceInDays";
import { Maybe } from "src/types.g";
import { BillingSubscription } from "./types";

export const getBillingSubscritionRemainDays = (
  billingSubscription: Maybe<Pick<BillingSubscription, "trialEnd">>,
) => {
  if (!billingSubscription?.trialEnd) {
    return null;
  }
  return differenceInDays(
    new Date(billingSubscription.trialEnd),
    new Date(Date.now()),
  );
};
